module.exports = __webpack_public_path__ + "img/carinalandin.2d777f41.png";